<div
  class="content"
  [class.multi-line]="isMultiLine"
  [class.standalone]="isStandalone"
>
  <strong>{{ label }}:</strong>
  <div><ng-content></ng-content></div>
</div>
